export const useCases = [
    {
      id: 1,
      title: "Optimizing Regression Testing for Large Test Suites",
      challenge: "An enterprise software company struggled with a large regression suite that took days to execute, delaying releases.",
      solution: "GAINSS analyzed historical execution data and defect patterns to prioritize tests for each sprint, reducing regression execution time by 50%.",
      outcome: "Teams released updates faster while maintaining high quality.",
    },
    // {
    //   id: 2,
    //   title: "Enhancing Test Coverage for a New Feature Release",
    //   challenge: "A gaming company had difficulty ensuring sufficient test coverage for a complex multiplayer feature.",
    //   solution: "GAINSS used AI to suggest additional test scenarios based on the feature’s user stories and historical data. It also identified gaps in test coverage.",
    //   outcome: "The team achieved 100% coverage of high-priority scenarios, preventing major defects in production.",
    // },
    {
      id: 3,
      title: "Managing Device Fragmentation for Mobile Testing",
      challenge: "A mobile app development team needed to test across hundreds of device and OS combinations but lacked an efficient way to plan and execute tests.",
      solution: "GAINSS automatically generated a device, OS, and browser matrix optimized for their user base, prioritizing devices based on usage analytics.",
      outcome: "Testing efforts were focused on key configurations, reducing unnecessary testing by 40%.",
    },
    // {
    //   id: 4,
    //   title: "Streamlining Localization Testing for Global Apps",
    //   challenge: "A global e-commerce company found it challenging to plan and execute localization tests across 20+ languages.",
    //   solution: "GAINSS automated the creation of localization execution matrices and flagged content inconsistencies using AI-powered anomaly detection.",
    //   outcome: "The team reduced planning time by 70% and ensured consistent quality across all locales.",
    // },
    {
      id: 5,
      title: "Accelerating Defect Analysis and Resolution",
      challenge: "A fintech company spent significant time manually linking defects to test cases, delaying failure analysis.",
      solution: "GAINSS auto-associated defects with their respective test cases and generated detailed defect reports with linked user stories.",
      outcome: "Defect triage time was reduced by 60%, enabling faster fixes and more efficient sprints.",
    },
    // {
    //   id: 6,
    //   title: "Supporting Risk-Based Testing for Critical Applications",
    //   challenge: "A healthcare technology company needed to focus testing efforts on high-risk areas to meet compliance standards.",
    //   solution: "GAINSS identified high-risk areas using AI-driven analysis of code changes, historical defects, and critical functionality.",
    //   outcome: "Teams prioritized 80% of their efforts on the most critical test cases, ensuring compliance while reducing overall test execution time.",
    // },
    {
      id: 7,
      title: "Scaling Automation Across Distributed Teams",
      challenge: "A SaaS company faced challenges integrating test automation results across multiple geographies in real time.",
      solution: "GAINSS provided API-driven integrations to synchronize automation results with the platform and deliver real-time updates on execution status.",
      outcome: "Global teams collaborated seamlessly, achieving a 70% reduction in manual result consolidation efforts.",
    },
    {
      id: 8,
      title: "Improving Production-Relevant Testing",
      challenge: "A media streaming company experienced defects in production due to untested user journeys and rare device combinations.",
      solution: "GAINSS leveraged data from production monitoring tools to design tests that replicated real user behavior, including edge cases.",
      outcome: "Defects in production decreased by 35%, improving customer satisfaction.",
    },
    // {
    //   id: 9,
    //   title: "Simplifying Cross-Browser Testing for Web Applications",
    //   challenge: "A financial services company spent excessive time manually managing cross-browser compatibility testing.",
    //   solution: "GAINSS automatically created a browser matrix based on analytics of browser usage by the company’s target audience, optimizing efforts.",
    //   outcome: "The team achieved comprehensive coverage of relevant browsers, reducing manual planning time by 50%.",
    // },
    {
      id: 10,
      title: "Automating Metrics and Reporting for Leadership",
      challenge: "Test managers at a logistics company spent hours consolidating test metrics to present to stakeholders.",
      solution: "GAINSS provided real-time dashboards with pre-built and customizable metrics, including defect trends, test coverage, and sprint progress.",
      outcome: "Leadership gained instant visibility into testing KPIs, and teams saved 15+ hours per sprint on reporting.",
    },
  ];
  